import { jsx as n, Fragment as m } from "react/jsx-runtime";
import * as o from "react";
import { m as j } from "../node_modules/streamdown/dist/chunk-RLXIAIE6.js";
import { Renderer as U } from "../node_modules/@openuidev/react-lang/dist/Renderer.js";
import "../node_modules/@openuidev/react-lang/dist/parser/types.js";
import "../node_modules/@openuidev/react-lang/dist/context.js";
import "../node_modules/@openuidev/react-lang/dist/hooks/useFormValidation.js";
import { useCopilotInstruction as Y } from "./global-state.js";
const g = o.createContext(null), h = o.createContext(null), C = o.createContext(!1);
function _({
  children: t,
  markdown: r,
  library: e,
  libraryPromptOptions: c,
  approval: v
}) {
  const d = o.useMemo(() => {
    const i = {}, { code: k = D, pre: P = B, ...M } = r ?? {};
    Object.assign(i, M);
    const I = P, W = k;
    return i.pre = function({ children: s, ...a }) {
      if (e != null) {
        const u = s?.props?.className ?? "";
        if (u === "language-openui")
          return /* @__PURE__ */ n(m, { children: s });
        const l = s?.props?.children;
        if (!u && typeof l == "string" && l.trimStart().startsWith(`openui
`))
          return /* @__PURE__ */ n(m, { children: s });
      }
      return /* @__PURE__ */ n(I, { ...a, children: s });
    }, i.code = function({ className: a, children: u, ...l }) {
      if (a === "language-openui" && e != null)
        return /* @__PURE__ */ n(f, { response: u, library: e });
      if (e != null && typeof u == "string" && !a) {
        const p = u.trimStart();
        if (p.startsWith(`openui
`) || p.startsWith(`openui\r
`)) {
          const S = p.replace(/^openui\r?\n/, "");
          return /* @__PURE__ */ n(f, { response: S, library: e });
        }
      }
      return /* @__PURE__ */ n(W, { ...l, className: a, children: u });
    }, i;
  }, [r, e]), x = o.useMemo(() => {
    const i = e != null ? e.prompt({
      ...c,
      preamble: "When rendering UI, emit an `openui` code fence. Inside the fence, write valid openui-lang. Everything outside the fence is regular markdown."
    }) : null;
    return [
      "## Content Guidelines",
      "",
      "1. You have access to github flavored markdown. Lean on it to make your responses more readable and engaging.",
      ...i != null ? [
        "2. You can also render rich UI components inline using an `openui` code fence. When you do, the fence content must be valid openui-lang — all syntax rules, component signatures, and streaming guidelines below apply to what goes inside the fence. Your prose outside the fence should remain standard markdown.",
        "",
        i
      ] : []
    ].join(`
`);
  }, [e, c]);
  Y({ instruction: x });
  const w = o.useMemo(() => ({ components: d }), [d]);
  return /* @__PURE__ */ n(g.Provider, { value: w, children: /* @__PURE__ */ n(h.Provider, { value: v ?? null, children: t }) });
}
function f({ response: t, library: r }) {
  const e = o.useContext(C);
  return t == null || t.trim() === "" ? null : /* @__PURE__ */ n(U, { response: t.trim(), library: r, isStreaming: e });
}
function q() {
  return o.useContext(h);
}
function z({
  children: t,
  isAnimating: r = !1,
  animated: e
}) {
  const c = o.useContext(g);
  if (c == null)
    throw new Error("Markdown must be used within CopilotProvider");
  return /* @__PURE__ */ n(C.Provider, { value: r ?? !1, children: /* @__PURE__ */ n(j, { components: c.components, animated: e, isAnimating: r, children: t }) });
}
function B(t) {
  return /* @__PURE__ */ n("pre", { ...t });
}
function D(t) {
  return /* @__PURE__ */ n("code", { ...t });
}
export {
  _ as CopilotProvider,
  z as Markdown,
  q as useCopilotApproval
};
